import { render, staticRenderFns } from "./PageApplicationMapsFertilizationCereals.vue?vue&type=template&id=60c4981d&"
import script from "./PageApplicationMapsFertilizationCereals.vue?vue&type=script&lang=ts&"
export * from "./PageApplicationMapsFertilizationCereals.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports